<template>
    <div>                
        <div class="mb-4">
            <div class="" v-if="questionnaire != null">
                <div class="row px-3">
                    <div class="col-12 py-1">
                        <h5>{{ stepName }}</h5>
                        <div v-if="questionnaire.information != null && questionnaire.information.length > 0" class="m-auto mb-3" v-dompurify-html="questionnaire.information"></div>
                    </div>
                    <div class="col-12">
                        <h6 v-if="questionnaire.interpretation != null && questionnaire.interpretation.length > 0">{{$t('INTERPRETATION')}}</h6>
                        <div v-if="questionnaire.interpretation != null && questionnaire.interpretation.length > 0" class="m-auto mb-3" v-dompurify-html="questionnaire.interpretation"></div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
export default {
    props: {
        questionnaire: Object,
        stepName: String
    },
    computed: {
        languages: function(){
            return this.$store.getters.systemLanguages;
        },
        selectedLanguage: function(){
            return this.$store.getters.selectedLanguage;
        },
    }
}
</script>
